export const N76 = {
  "columns": 6  ,
  "rows": 1,
  "visual": {
    "id": 1,
    "type": "combo",
    "colorTheme": "colorTheme1",
    "title": "Quarterly % Growth (FY vs LY)",
    "orientation": "vertical",
    "xAxis": "",
    "yAxis": "",
    "binding": {
      "data": {
        "series": [
          {
            "name": "Actual Sales",
            "value": "ActualSales",
            "type": "column"
          },
          {
            "name": "LY Sales",
            "value": "LastSales",
            "type": "column"
          },
          {
            "name": "Growth %",
            "value": "Growth",  
            "type": "line",
            "yAxisIndex": 1   
          }
        ],
        "title": "Quarter",
        "endpoint": "N76", 
        "parameters": [
           { "key": "FromMonth", "value": "2024" },
           { "key": "FromYear", "value": "1" },
           { "key": "ToMonth", "value": "2024" },
           { "key": "ToYear", "value": "1" },
           { "key": "ConfigTypeCode", "value": "" }
        ]
      },
      "context": {
        "point": {
          "onClick": {}
        }
      }
    }
  }
}
